import { axios } from '../libs/axios';

export function submitUserInfo(data) {
    return axios.file('/index.php/home/mail/enrol', data);
}

// export function addMessage(data) {
//     return axios.post('/website/leaveMessage/add', data);
// }

export function getCountryList(params) {
    return axios.get('/system/dict/getList', params);
}
//奥托登录
export function getLogin(data) {
    return axios.post('/robot/login', data);
}
//获取产品类型
export function getType(data) {
    return axios.post('/robot/type', data);
}
//获取产品列表
export function getRlist(data,name) {
    return axios.post('/robot/rlist?robotTwo=' + data + '&robotName='+  name, data);
}

//在线留言
export function addMessage(data) {
    return axios.post('/system/notice/addbyindex', data);
}

